










































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  ShipmentDTO,
  AddressShipmentDTO,
  ContactDTO,
  ShipmentExtraServiceDTO
} from "../../../model/data.model";
import ShipmentForm from "./ShipmentForm.vue";
import { ShipmentService } from "../../../services/ShipmentService";
import { ContactService } from "../../../services/ContactService";
import { EventBus } from "../../../event-bus";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import PostSaveModal from "./PostSaveModal.vue";
import i18n from "../../../lang/i18n";
import router from "../../../router/router";
import store from "../../../vuex/store";
import { getStoreCompanyName, translateErrorMessage } from "@/services/Helpers";
import { reportError } from "@/utils/instana";
import { cloneDeep } from "lodash";
import { paperlessDocumentsToSave } from "@/model/paperlessPostClosure.model";

@Component({
  components: {
    ShipmentForm: ShipmentForm
  }
})
export default class EditShipment extends Vue {
  shipment: ShipmentDTO = new ShipmentDTO();
  dummmyShipment: ShipmentDTO = new ShipmentDTO();

  editedShipment = false;
  newCreatedShipment = false;
  ready = false;

  senderAddressOperation = "DONTSAVE";
  receiverAddressOperation = "DONTSAVE";

  senderContact: ContactDTO | undefined = undefined;
  receiverContact: ContactDTO | undefined = undefined;

  contactService: ContactService;
  // used another var to call update contact api, instead of visible flag, to keep user experience as before
  overwriteSenderContactInfos = false;
  overwriteReceiverContactInfos = false;

  async created() {
    const id = this.$route.params.id;
    if (id != null) {
      this.newCreatedShipment =
        this.$route.params.newCreatedShipment === "true";
      await ShipmentService.getShipment(id)
        .then(res => {
          this.shipment = ShipmentDTO.cloneShipment(res);
          this.dummmyShipment = cloneDeep(ShipmentDTO.cloneShipment(res));
          this.seedZonosStore(res);
          this.shipment.priceSource = res.priceSource;
          if (res.pickup !== null) {
            this.shipment.pickup = res.pickup;
          }
          if (res.hasAttachment !== null) {
            this.shipment.hasAttachment = res.hasAttachment;
            this.dummmyShipment.hasAttachment = res.hasAttachment;
          }
          if (
            !this.shipment.addressStore.macroareaName ||
            this.shipment.addressStore.macroareaName === ""
          ) {
            //workaround for some bad addresses from BE, they should fix on their side later
            // temp workaournd for 748724888
            this.refreshStoreAddress();
          }
          this.resolveSafeValueConflict();
        })
        .catch(error => {});
    } else {
      this.shipment.customerId = this.$store.getters[
        "customer/info"
      ].customerId;
      this.shipment.storeId = this.$store.getters[
        "customer/info"
      ].defaultStoreId;
      this.shipment.locale = "Europe/Rome";
    }

    this.ready = true;
    this.contactService = new ContactService(
      this.$store.getters["customer/customerMbeId"]
    );
  }

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }
  resolveSafeValueConflict() {
    if (
      this.shipment.extraServices &&
      this.shipment.extraServices.length !== 0
    ) {
      const sv4b = this.shipment.extraServices.find(
        e => e.mbeBusinessId === 300
      );
      const sv = this.shipment.extraServices.find(e => e.mbeBusinessId === 1);
      if (sv4b && sv) {
        if (sv.price && sv4b.price) {
          if (sv4b.autoAdded) {
            this.shipment.extraServices.splice(
              this.shipment.extraServices.indexOf(sv),
              1
            );
            const svProd = this.shipment.shipMBEProducts.find(
              p => p.idSpecialtyBusiness === 1
            );
            if (svProd) {
              this.shipment.shipMBEProducts.splice(
                this.shipment.shipMBEProducts.indexOf(svProd),
                1
              );
            }
          } else {
            this.shipment.extraServices.splice(
              this.shipment.extraServices.indexOf(sv4b),
              1
            );
            const sv4bProd = this.shipment.shipMBEProducts.find(
              p => p.idSpecialtyBusiness === 5
            );
            if (sv4bProd) {
              this.shipment.shipMBEProducts.splice(
                this.shipment.shipMBEProducts.indexOf(sv4bProd),
                1
              );
            }
          }
        } else if (!sv.price) {
          this.shipment.extraServices.splice(
            this.shipment.extraServices.indexOf(sv),
            1
          );
          const svProd = this.shipment.shipMBEProducts.find(
            p => p.idSpecialtyBusiness === 1
          );
          if (svProd) {
            this.shipment.shipMBEProducts.splice(
              this.shipment.shipMBEProducts.indexOf(svProd),
              1
            );
          }
        } else if (!sv4b.price) {
          this.shipment.extraServices.splice(
            this.shipment.extraServices.indexOf(sv4b),
            1
          );
          const sv4bProd = this.shipment.shipMBEProducts.find(
            p => p.idSpecialtyBusiness === 5
          );
          if (sv4bProd) {
            this.shipment.shipMBEProducts.splice(
              this.shipment.shipMBEProducts.indexOf(sv4bProd),
              1
            );
          }
        }
      }
    }
  }
  setAddressForAsCustomer() {
    const customerBusinessName = this.$store.getters["customer/info"]
      .businessName;
    const customerContact = this.$store.getters["customer/info"].address;
    if (customerContact.addresses.length >= 1) {
      this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
        customerContact,
        customerContact.addresses[0],
        "",
        "NATIONAL",
        customerBusinessName
      );
    }
    this.calculateMacroAreaForAddress("addressFor");
  }
  calculateMacroAreaForAddress(addressType: string) {
    store.cache
      .dispatch("shipment/getMacroareaForContact", {
        zipCode: this.shipment[addressType].zipCode,
        countryId: this.shipment[addressType].countryId
      })
      .then(value => (this.shipment[addressType].macroareaName = value));
  }

  saveShipment() {
    try {
      if (this.isInboundShipment) {
        this.shipment.shipmentDirection = "INBOUND";
      } else {
        this.shipment.shipmentDirection = "OUTBOUND";
      }
      this.shipment.customerDataInSender = this.$store.getters[
        "customer/info"
      ].custConfiguration.customerAsSender;
      this.shipment.customerDataInSenderExceptForAddress = this.$store.getters[
        "customer/info"
      ].custConfiguration.customerAsSenderExceptforAddress;
      const customerBusinessName = this.$store.getters["customer/info"]
        .businessName;
      const customerContact = this.$store.getters["customer/info"].address;
      if (customerContact.addresses.length >= 1) {
        this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
          customerContact,
          customerContact.addresses[0],
          "",
          "NATIONAL",
          customerBusinessName
        );
      }
      const isAutopilotFee = this.shipment.extraServices.find(
        e => e.mbeBusinessId == 235
      );
      if (isAutopilotFee) this.shipment.autopilotFee = true;
      if (this.shipment.customerDepartmentId === 0) {
        this.setAddressForAsCustomer();
      } else {
        this.$store.getters["customer/departments"].forEach(dep => {
          if (dep.departmentId === this.shipment.customerDepartmentId) {
            this.shipment.addressFor = dep.address;
            this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
              dep.address,
              dep.address.addresses[0],
              "",
              "NATIONAL",
              dep.departmentBusinessName
            );
            this.calculateMacroAreaForAddress("addressFor");
          }
        });
      }
      this.refreshStoreAddress();

      this.shipment.totalNumberOfPackages = this.shipment.shipmentPackages.length;

      (this.$refs.shipmentForm as ShipmentForm)
        .fillCourierAccountIfNecessary()
        .then(() => {
          this.confirmSaveShipment()
            .then(() => {
              // Operations over addresses
              switch (this.senderAddressOperation) {
                case "NEW":
                  this.contactService.saveContact(
                    this.shipment.addressFrom.toContactDTO()
                  );
                  break;
                case "OVERWRITE":
                  if (this.overwriteSenderContactInfos) {
                    this.contactService.updateContact(
                      this.shipment.addressFrom.toContactDTO(
                        this.senderContact
                      ),
                      []
                    );
                  }
                  break;
                case "DONTSAVE":
                  break;

                case "SAVEASPICKUP":
                  this.contactService.saveContact(
                    this.shipment.addressFrom.toContactDTO()
                  );
                  break;
              }

              switch (this.receiverAddressOperation) {
                case "NEW":
                  this.contactService.saveContact(
                    this.shipment.addressTo.toContactDTO()
                  );
                  break;
                case "OVERWRITE":
                  if (this.overwriteReceiverContactInfos) {
                    this.contactService.updateContact(
                      this.shipment.addressTo.toContactDTO(
                        this.receiverContact
                      ),
                      []
                    );
                  }
                  break;
                case "DONTSAVE":
                  break;
              }
            })
            .catch(err => {
              let message =
                "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
              message += "<p>" + translateErrorMessage(err) + "</p>";
              if (err?.response?.status === 400) {
                const objectErr =
                  err.response.data.length > 0
                    ? err.response.data[0]
                    : err.response.data;
                reportError(err, {
                  meta: { response: JSON.stringify(objectErr) }
                });
              }
              return AlertBus.$alerts.danger(message);
            });
        });
    } catch (error) {
      console.error(error);
    }
  }

  shipmentMessages: any[] = [];

  // Closed shipment: start from the shipment as loaded so only the paperless documents change
  savePaperlessDocuments(messages: any[] = []): Promise<void> {
    const shipmentToSave = cloneDeep(this.dummmyShipment);
    Object.assign(
      shipmentToSave,
      paperlessDocumentsToSave(
        this.shipment.sentPaperlessDocument,
        this.shipment.paperlessDocumentIds
      )
    );

    return ShipmentService.saveShipment(
      shipmentToSave,
      this.$store.getters["customer/info"].tenantId,
      this.$store.getters["customer/info"].multiStoreId,
      false,
      false,
      messages
    )
      .then((res: any) => {
        const resMessages = res.messageResult && res.messageResult.messages;
        if (resMessages && resMessages.length > 0) {
          let title = "<ul>";
          resMessages.forEach((mex: any) => {
            const message =
              mex.description !== undefined
                ? mex.code + " " + mex.description
                : String(this.$t(mex.code));
            title += "<li>" + message + "</li>";
          });
          title += "</ul>";
          if (resMessages.some((mex: any) => mex.responseType === "ERROR")) {
            return AlertBus.$alerts.danger(
              "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>" + title
            );
          }
          return AlertBus.$alerts
            .confirm("<h5>" + this.$t("SAVE_ANYWAY") + "</h5></br>" + title)
            .then((resp: boolean) => {
              if (resp) return this.savePaperlessDocuments(resMessages);
              return undefined;
            });
        }
        this.$snotify.success(
          this.$t("paperless_documents_saved_successfully").toString()
        );
        this.$router.push({
          name: "ShipmentsManagement",
          params: { searchTab: "shipment_status_processing" }
        });
      })
      .catch(err => {
        let message = "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
        message += "<p>" + translateErrorMessage(err) + "</p>";
        if (err?.response?.status === 400) {
          const objectErr =
            err.response.data.length > 0
              ? err.response.data[0]
              : err.response.data;
          reportError(err, {
            meta: { response: JSON.stringify(objectErr) }
          });
        }
        return AlertBus.$alerts.danger(message);
      });
  }

  // On reopen zonosId is stored at shipment top level: seed the store so the detail tooltip loads and the save round-trips it.
  // Reset first so a previously opened shipment cannot leak its landed cost / zonosId onto this one (shared Vuex value).
  seedZonosStore(res: any): void {
    this.$store.commit("shipment/setZonosCalculateResponse", null);
    if (!res.landedCosts || Object.keys(res.landedCosts).length === 0) {
      return;
    }
    const landedCosts = cloneDeep(res.landedCosts);
    if (res.zonosId) {
      landedCosts.zonosId = res.zonosId;
    }
    this.$store.commit("shipment/setZonosCalculateResponse", landedCosts);
  }

  applyZonosIdFromStore(): void {
    const zonosResponse = this.$store.getters[
      "shipment/zonosCalculateResponse"
    ];
    this.shipment.zonosId =
      zonosResponse && zonosResponse.zonosId
        ? zonosResponse.zonosId
        : undefined;
  }

  confirmSaveShipment(): Promise<void> {
    if (this.isInboundShipment) {
      this.shipment.shipmentDirection = "INBOUND";
    } else {
      this.shipment.shipmentDirection = "OUTBOUND";
    }
    this.applyZonosIdFromStore();
    return ShipmentService.saveShipment(
      this.shipment,
      this.$store.getters["customer/info"].tenantId,
      this.$store.getters["customer/info"].multiStoreId,
      this.$store.getters["customer/config"].canPrintWaybill,
      false,
      this.shipmentMessages
    ).then((res: any) => {
      this.shipmentMessages = [];
      const messages = res.messageResult && res.messageResult.messages;
      if (messages && messages.length > 0) {
        // There are some errors
        let title = "<ul>";
        let updateZTL = false;
        messages.forEach((mex: any) => {
          this.shipmentMessages.push(mex);
          let message = String(this.$t(mex.code));
          if (mex.responseType === "ERROR") {
            // for courier exception(s) that can have unknown errors from ext. systems
            if (!this.$t(mex.code)) {
              let msgCode = mex.code;
              if (mex.code === undefined) {
                msgCode = this.$t("UNEXPECTED_ERROR");
              }
              message = msgCode + " " + mex.description;
            } else {
              if (mex.description !== undefined)
                message = mex.code + " " + mex.description;
            }
          }
          title += "<li>" + message + "</li>";
          if (mex.code === "AUTO_ADDED_SURCHARGE_ALERT") {
            const params = mex.params;
            for (const param of params) {
              let value = param;
              if (!isNaN(param)) {
                value = this.$t("extraService_" + param);
              }
              title += "&nbsp;- " + value + "<br/>";
            }
          }
          if (mex.code === "GLS_WARN_RECEIVER_ZTL") {
            //we ask to confirm address update
            updateZTL = true;
          }
        });
        if (messages.some((mex: any) => mex.responseType === "ERROR")) {
          let message = "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
          message += title + "</ul>";
          return AlertBus.$alerts.danger(message);
        }

        let message = "<h5>" + this.$t("SAVE_ANYWAY") + "</h5></br>";
        message += title + "</ul>";

        AlertBus.$alerts.confirm(message).then((resp: boolean) => {
          if (resp) {
            if (updateZTL) {
              this.shipment.addressTo.ltz = true;
            }
            this.confirmSaveShipment();
          }
        });
      } else {
        this.$snotify.success(
          this.$t("notification_shipment_created").toString()
        );

        const temp_shipment = ShipmentDTO.cloneShipment(this.shipment);
        temp_shipment.shipmentId = res.shipment.shipmentId;
        temp_shipment.status = res.shipment.status;

        const modalConstructor = Vue.extend(PostSaveModal);

        const modal = new modalConstructor({
          i18n,
          router,
          store,
          propsData: {
            shipment: temp_shipment // this.shipment
          }
        });

        EventBus.$emit("to-modal", modal);
      }
    });
  }

  deleteSenderAddress() {
    //this.shipment.addressFrom = new AddressShipmentDTO();
    this.senderAddressOperation = "NEW";
    this.senderContact = undefined;
  }

  saveAsPickup() {
    this.senderAddressOperation = "SAVEASPICKUP";
  }

  deleteReceiverAddress() {
    //this.shipment.addressTo = new AddressShipmentDTO();
    this.receiverAddressOperation = "NEW";
    this.receiverContact = undefined;
  }

  senderAddressLoaded(contact: ContactDTO) {
    this.senderAddressOperation = "OVERWRITE";
    this.senderContact = contact;
  }

  receiverAddressLoaded(contact: ContactDTO) {
    this.receiverAddressOperation = "OVERWRITE";
    this.receiverContact = contact;
  }
  addExtraService(extraService: ShipmentExtraServiceDTO) {
    this.shipment.extraServices = this.shipment.extraServices.filter(
      item => item.extraServiceName !== extraService.extraServiceName
    );
    extraService.price = true;
    this.shipment.extraServices.push(extraService);
    if (this.shipment.dismissedExtraServices) {
      this.shipment.dismissedExtraServices = this.shipment.dismissedExtraServices.filter(
        item => item.extraServiceName !== extraService.extraServiceName
      );
    }
  }

  removeExtraService(event: any) {
    const extraService = this.shipment.extraServices.filter(
      item => item.extraServiceName === event.extraServiceName
    )[0];
    if (!event.autoAdded) {
      this.shipment.extraServices = this.shipment.extraServices.filter(
        item => item.extraServiceName !== event.extraServiceName
      );
    } else {
      this.shipment.extraServices.forEach((item, index) => {
        if (item.extraServiceName === event.extraServiceName) {
          this.shipment.extraServices[index].dismissed = true;
          this.shipment.extraServices[index].price = false;
          this.shipment.extraServices[index].cost = false;
        }
      });
    }
    extraService.dismissed = true;
    extraService.price = false;
    extraService.cost = false;
    this.shipment.dismissedExtraServices.push(extraService);
  }

  refreshStoreAddress() {
    const storeAddresses = this.$store.getters["customer/storeAddresses"];
    const storeName = getStoreCompanyName(
      this.$store.getters["customer/storeInfo"].store.multiStore
    );
    if (storeAddresses.length >= 1) {
      this.shipment.addressStore = AddressShipmentDTO.fromAddressDTO(
        storeAddresses[0],
        storeName,
        "",
        "NATIONAL",
        this.$store.getters["customer/storeInfo"].contactReferences
      );
    }
  }

  get isWineShipment() {
    return (
      (this.$route.query.type === "wine" || this.hasWineProduct) &&
      (this.$store.getters["customer/config"].enableWineShipmentCreation ||
        this.$store.getters["customer/config"].enableSpiritsShipmentCreation)
    );
  }

  get hasWineProduct() {
    const validIds = [6, 8, 9, 10];
    return (
      this.shipment.shipMBEProducts?.some(product =>
        validIds.includes(product.idSpecialtyBusiness)
      ) || false
    );
  }
}
